import React, { FC } from 'react';
import Modal from 'styled-react-modal';

import { useTranslations } from '@lang';
import { CloseModalButton } from '@common/components/BookingForms/Modal';

import { Description, Image } from '../../shared';
import { Wrapper, Header, Name, ReturnButton } from './DetailsModal.styles';

type DetailsModalProps = {
  closeModal: () => void;
  description: string;
  imageUrl: string;
  isOpen: boolean;
  name: string;
};

const DetailsModal: FC<DetailsModalProps> = ({
  closeModal,
  description,
  imageUrl,
  isOpen,
  name,
}) => {
  const { t } = useTranslations();

  return (
    <Modal isOpen={isOpen}>
      <Wrapper>
        <Header>
          <CloseModalButton onClick={closeModal} />
        </Header>
        <Image imageUrl={imageUrl} alt={name} isWiderViewport={false} />
        <Name>{name}</Name>
        <Description description={description} />
        <ReturnButton type="button" onClick={closeModal}>
          {t('spa.returnToOptions')}
        </ReturnButton>
      </Wrapper>
    </Modal>
  );
};
export default DetailsModal;
